import axios from 'axios'
import { getFirstErrorMessage, getErrorMessage, getErrorMessages } from '~/lib/axios'
import config from '../lib/config'
const {CONFIG: {apiUri: APIURI}} = config


export default {
  getFirstErrorMessage,
  getErrorMessage,
  getErrorMessages,

  async forgotPassword(request) {
    // {email, reseturl}
    const { data } = await axios.post(`${APIURI}/user/password/forgot`, request);
    return data;
  },
  async sendConfirmation(request) {
    // {email}
    const { data } = await axios.post(`${APIURI}/user/register/resend`, request);
    return data;
  },
  async notifyOrder(order) {
    const { data } = await axios.post(`${APIURI}/customer/order/${order.id}/notify`, {
      guest: {
        id: order.user.data.id,
        email: order.user.data.email,
      }
    });
    return data;
  },
  async updateUser(id, payload) {
    const { data } = await axios.put(`${APIURI}/user/${id}`, payload)
    return data;
  }

}
